import { useTranslation } from "react-i18next";
import { useBackUrl } from "../store/hooks";
import Layout from "./common/Layout";

const Failure = () => {
  const backUrl = useBackUrl();
  const { t } = useTranslation();

  return (
    <Layout>
      <div className="result-page-container">
        <div className="result-header">
          <div className="mb-3">
            <img
              src={process.env.PUBLIC_URL + "/images/error-cross.svg"}
              alt="Error Cross Icon"
              className="result-icon"
            />
          </div>
          <h1 className="error-page-title">{t("errorPage.title")}</h1>
        </div>

        <div className="result-content mt-3">
          <p className="result-page-message">{t("errorPage.message")}</p>
          <p className="result-page-message">{t("errorPage.subMessage")}</p>
        </div>

        <div
          className="az-btn mt-4 w-100"
          onClick={() => (window.location.href = backUrl)}
        >
          {t("back.label")}
        </div>
      </div>
    </Layout>
  );
};

export default Failure;
